import type { SVGProps } from 'react'

export const CalendarClockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 4.44141V6.02344H14V4.44141C14 3.568 13.3281 2.85938 12.5 2.85938H11V1.80469C11 1.22131 10.5531 0.75 10 0.75C9.44689 0.75 9.00001 1.22131 9.00001 1.80469V2.85938H5.00001V1.80469C5.00001 1.22131 4.55313 0.75 4.00001 0.75C3.44688 0.75 3 1.22131 3 1.80469V2.85938H1.5C0.671876 2.85938 0 3.568 0 4.44141ZM0 7.07813V16.043C0 16.9164 0.671876 17.625 1.5 17.625H10.3375C8.92501 16.5736 8.00001 14.84 8.00001 12.8789C8.00001 9.6753 10.4625 7.07813 13.5 7.07813H0ZM13.5 7.07813C13.6688 7.07813 13.8344 7.08472 14 7.1012V7.07813H13.5Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M13.5 17.625C14.6935 17.625 15.8381 17.125 16.682 16.2349C17.5259 15.3448 18 14.1377 18 12.8789C18 11.6202 17.5259 10.413 16.682 9.52291C15.8381 8.63285 14.6935 8.13281 13.5 8.13281C12.3065 8.13281 11.1619 8.63285 10.318 9.52291C9.47411 10.413 9 11.6202 9 12.8789C9 14.1377 9.47411 15.3448 10.318 16.2349C11.1619 17.125 12.3065 17.625 13.5 17.625ZM14 10.7695V12.3516H15C15.275 12.3516 15.5 12.5889 15.5 12.8789C15.5 13.169 15.275 13.4063 15 13.4063H13.5C13.225 13.4063 13 13.169 13 12.8789V10.7695C13 10.4795 13.225 10.2422 13.5 10.2422C13.775 10.2422 14 10.4795 14 10.7695Z"
      fill="currentColor"
    />
  </svg>
)
